import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';

/**
 * 로그인 사용자 역할의 허용 메뉴 트리 조회
 * GET /api/user/comm/menu/myMenus
 *
 * 반환 형태 (트리):
 * [
 *   { menuCode: "COMM", menuName: "기준관리", path: "/comm", children: [...] },
 *   { menuCode: "COMP", menuName: "회사관리", path: "/comp", children: [...] },
 *   ...
 * ]
 *
 * @param {boolean} isAuthenticated - 로그인 상태일 때만 호출
 */
const useMyMenus = (isAuthenticated) => {
    return useQuery({
        queryKey: ['myMenus'],
        queryFn: () => get('/user/comm/menu/myMenus').then(res => res?.result ?? []),
        enabled: !!isAuthenticated,
        staleTime: 5 * 60 * 1000, // 5분 캐시 (메뉴는 자주 바뀌지 않음)
    });
};

export default useMyMenus;
